import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppContextProvider } from './'
import config from '../config'
import themes from '../../features/navigation/themes'
import { doLogin } from '../../features/account/store'

class AppProvider extends React.Component {
  constructor(props) {
    super(props)

    this.toggleSidebar = () => this.setState(prevState => ({ sidebar: !prevState.sidebar }))
    this.closeSidebar = () => this.setState(prevState => ({ sidebar: false }))

    this.toggleGlobalMap = layers => this.setState(prevState => ({ globalMap: !prevState.globalMap, globalMapLayers: layers || [] }))
    this.closeGlobalMap = () => this.setState(prevState => ({ globalMap: false, globalMapLayers: [] }))

    this.setCurrentTheme = theme => this.setState({ currentTheme: theme })

    this.state = {
      config: {...config, ...this.props.config},
      templates: this.props.templates,
      themes: {...themes, ...this.props.extend.themes},
      extend: {...this.props.extend},

      currentTheme: null,
      setCurrentTheme: this.setCurrentTheme,

      sidebar: false,
      toggleSidebar: this.toggleSidebar,
      closeSidebar: this.closeSidebar,

      globalMap: false,
      globalMapLayers: [],
      toggleGlobalMap: this.toggleGlobalMap,
      closeGlobalMap: this.closeGlobalMap,
    }
  }

  componentDidMount() {
    this.props.doLogin()
  }

  render() {
    // TODO show offline mode bar
    // this.props.account.isOffline &&
    //   <div className="Offline-mode">{translate('app.offlineMode')}</div>

    return (
      <AppContextProvider value={{...this.state, account: this.props.account}}>
        <div className="App">
          {this.props.children}
        </div>
      </AppContextProvider>
    )
  }
}

export default withRouter(connect(
  (state, props) => ({
    account: state.account,
  }),
  (dispatch) => ({
    doLogin: () => dispatch(doLogin()),
  })
)(AppProvider))
